import { render, staticRenderFns } from "./IndividualUniversityPurchase.vue?vue&type=template&id=1ff91aee"
import script from "./IndividualUniversityPurchase.vue?vue&type=script&lang=js"
export * from "./IndividualUniversityPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports